import React, { useState, useEffect, useMemo } from "react";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { Download } from "react-feather";
import { GlobalFilter } from "../GlobalFilter";
import { useNavigate, useParams } from "react-router-dom";
import Global from "../../utils/Global";

export function TrialTable({ trials, isLoading, setSelectedRowName, setSelectedRowId, allowTwoSelections, ...props }) {
  const navigate = useNavigate();
  const { subjectId } = useParams();
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);

  const onRowClick = (row) => {
    const newPath = `/dashboard/${subjectId}/trials/${trials[row.index].trial_id}`;

    Global.localAppHandler.app_set_active_trial(trials[row.index].trial_id).then((trial_id) => {
      navigate(newPath);
    }).catch((returnStatus) => {
      console.log("this should never happen");
    })
  };

  const patientsData = useMemo(() => [...trials], [trials]);

  const patientsColumns = useMemo(
    () =>
      trials[0]
        ? Object.keys(trials[0])
            .filter((key) => key === "_trial_name" || key === "_trial_date")
            .map((key) => {
              var title = key;
              if (key === "_trial_name") {
                title = "Trial Name";
              } else if (key === "_trial_date") {
                title = "Trial Date";
                return {
                  Header: title,
                  accessor: key,
                  Cell: ({ value }) => {
                    // Convert value from UTC to local date
                    const date = new Date(value);
                    return date.toLocaleString(); // You can also use toLocaleDateString() or toLocaleTimeString() to customize the format
                  },
                };
              }
              return { Header: title, accessor: key };
            })
        : [],
    [trials]
  );

  const tableInstance = useTable(
    { columns: patientsColumns, data: patientsData, initialState: { hiddenColumns: ["trial_id"] }, getTrProps: onRowClick },
    useGlobalFilter,
    // tableHooks,
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, preGlobalFilteredRows, setGlobalFilter, state } = tableInstance;
  useEffect(() => {
    if (rows && rows[0] && setSelectedRowName) {
      setSelectedRowName(rows[0].values.trial_name);
    }
    if (rows && rows[0] && setSelectedRowId) {
      setSelectedRowId(rows[0].values.trial_id);
    }
  }, [rows, setSelectedRowName, setSelectedRowId]);

  return (
    <>
      <GlobalFilter preGlobalFilteredRows={preGlobalFilteredRows} setGlobalFilter={setGlobalFilter} globalFilter={state.globalFilter} />
      <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>

      <table className="table table-bordered" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <img src={require("../../images/down_arrow.png")} alt="" />
                    ) : (
                      <img src={require("../../images/up_arrow.png")} alt="" />
                    )
                  ) : column.Header === "Actions" ? (
                    ""
                  ) : (
                    <img src={require("../../images/default.png")} alt="" />
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {isLoading ? (
            <tr><td colSpan={patientsColumns.length}>Loading...</td></tr>
          ) : rows.length > 0 ? (
            rows.map((row, rowIdx) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  onMouseEnter={() => setHoveredRowIndex(rowIdx)}
                  onMouseLeave={() => setHoveredRowIndex(null)}
                  style={{
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    onRowClick(row);
                  }}
                >
                  {row.cells.map((cell, idx) => (
                    <td 
                    className={hoveredRowIndex === rowIdx ? "link-primary" : ""}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                  ))}
                </tr>
              );
            })
          ) : (
            <tr><td colSpan={patientsColumns.length}>No Trials Recorded.</td></tr>
          )}
        </tbody>
      </table>
      </div>
    </>
  );
}
